<script setup></script>
<template>
    <layout-content>
        <head-title value="Accessibility Settings" />
        <content-header>
            <top-nav>
                <top-nav-back />
                <top-nav-title>
                    Accessibility
                </top-nav-title>
            </top-nav>
        </content-header>

        <content-body>
            <div class="p-4">
                <div class="font-semibold">
                    Dark mode
                </div>
                <div class="flex flex-col">
                    <button type="button" class="text-left px-4 py-2 flex items-center" @click="$settings.setDarkModeOff()">
                        <span>Off</span>
                        <div class="ml-auto size-5 border border-primary rounded-full flex items-center justify-center">
                            <div :data-active="$settings.darkModePreference === 'off'" class="w-4/6 h-4/6 data-[active=true]:bg-primary rounded-full"></div>
                        </div>
                    </button>
                    <button type="button" class="text-left px-4 py-2 flex items-center" @click="$settings.setDarkModeOn()">
                        <span>On</span>
                        <div class="ml-auto size-5 border border-primary rounded-full flex items-center justify-center">
                            <div :data-active="$settings.darkModePreference === 'on'" class="w-4/6 h-4/6 data-[active=true]:bg-primary rounded-full"></div>
                        </div>
                    </button>
                    <button type="button" class="text-left px-4 py-2 flex items-center" @click="$settings.setDarkModeDevice()">
                        <span>Use device settings</span>
                        <div class="ml-auto size-5 border border-primary rounded-full flex items-center justify-center">
                            <div :data-active="$settings.darkModePreference === 'device'" class="w-4/6 h-4/6 data-[active=true]:bg-primary rounded-full"></div>
                        </div>
                    </button>
                </div>
            </div>
        </content-body>
    </layout-content>
</template>
